import { render, staticRenderFns } from "./PersonalSkills.vue?vue&type=template&id=ed3d0260"
import script from "./PersonalSkills.vue?vue&type=script&lang=js"
export * from "./PersonalSkills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports